module.exports = __webpack_public_path__ + "static/media/gdp.eef6d1e0.svg";